import React from 'react'
import PropTypes from 'prop-types'
import { StyledSingleLogoWrapper, StyledLogoLink, StyledIcon } from './styles'

const LogoLink = (props) => {
  const { link, logo, label, onClick } = props

  return (
    <StyledSingleLogoWrapper onClick={onClick}>
      <StyledLogoLink to={link} aria-label={label}>
        <StyledIcon src={logo.url} alt={logo.alt || label} loading="lazy" />
      </StyledLogoLink>
    </StyledSingleLogoWrapper>
  )
}

LogoLink.defaultProps = {
  link: '',
  label: '',
  logo: {},
}

LogoLink.propTypes = {
  link: PropTypes.string,
  label: PropTypes.string,
  logo: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
  }),
  onClick: PropTypes.func,
}

export { LogoLink }
